var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.81484 2.37061H2.29219C1.94948 2.37061 1.6208 2.50675 1.37847 2.74908C1.13614 2.99141 1 3.32008 1 3.66279V12.7081C1 13.0508 1.13614 13.3795 1.37847 13.6218C1.6208 13.8641 1.94948 14.0003 2.29219 14.0003H11.3375C11.6802 14.0003 12.0089 13.8641 12.2512 13.6218C12.4935 13.3795 12.6297 13.0508 12.6297 12.7081V8.18544",
    stroke: "#3D7EA6",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.6604 1.40143C11.9175 1.1444 12.2661 1 12.6296 1C12.9931 1 13.3417 1.1444 13.5987 1.40143C13.8558 1.65846 14.0002 2.00707 14.0002 2.37057C14.0002 2.73407 13.8558 3.08268 13.5987 3.33971L7.46084 9.4776L4.87646 10.1237L5.52256 7.53932L11.6604 1.40143Z",
    stroke: "#3D7EA6",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/edit.ed83474e931859c0a7afffdf2099681a.svg";
export { ForwardRef as ReactComponent };